<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h3>{{$t('textRegulatoryAffairs.textLabelTitle')}}</h3>
                <p>{{data.titulo}}</p>
            </div>
            <div class="col-6">
                <h3>{{$t('textRegulatoryAffairs.textLabelPeriodicidad')}}</h3>
                <p>{{data.periodicidad}}</p>
            </div>
            <div class="col-6">
                <h3>Relevancia</h3>
                <p>{{data.relevancia}}</p>
            </div>
            <div class="col-12">
                <h3>Descripcion</h3>
                <p>{{data.descripcion}}</p>
            </div>
            <div class="col-12" v-if="data.fechas.length > 1">
                <h3>Fechas</h3>
                <ejs-grid ref='grid' :dataSource='data.fechas'>
                    <e-columns>
                        <e-column field="fecha_cumplimiento" headerText="FECHA CUMPLIMIENTO"></e-column>
                        <e-column :template="validateStatus" headerText="ESTADO"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                <h3>Normas</h3>
                <ejs-grid ref='grid' :dataSource='data.normas'  :allowPaging="true" :allowSorting="true" :pageSettings='pageSettings' :toolbar='toolbar' :searchSettings='searchOptions'>
                    <e-columns>
                        <e-column field="prefijo" :headerText="$t('gridHeaderText.prefix')"></e-column>
                        <e-column field="articulo" :headerText="$t('gridHeaderText.article')"></e-column>
                        <e-column field="tipo_norma" :headerText="$t('gridHeaderText.standard_type')"></e-column>
                        <e-column field="numero" :headerText="$t('gridHeaderText.number')"></e-column>
                        <e-column field="anio" :headerText="$t('gridHeaderText.year')"></e-column>
                        <e-column field="denominacion" :headerText="$t('gridHeaderText.denomination')"></e-column>
                        <e-column field="razonSocial" :headerText="$t('gridHeaderText.tenant')"></e-column>
                        <e-column headerText="OPCIONES" textAlign="center" width="160px"  :template="templateButtons"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { Page, Sort, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
export default {
    name: 'view-compliance',
    props: ["data"],
    provide: {
        grid: [Sort, Page, Toolbar, Search]
    },
    data() {
        return {
            toolbar: ['Search'],
            pageSettings: { pageSize: 20 },
            searchOptions: {ignoreAccent: true},

            templateButtons: function (e) {
                return {
                    template: Vue.component('templateButtons', {
                        template: `<div class="text-center">
                                        <a v-on:click="onRuleEdit(data)" class="btn btn-sm btn-primary">Actualizar</a>
                                        <a v-on:click="onUnpin(data)" class="btn btn-sm e-btn e-primary" style="text-transform: none !important;">Desasociar</a>
                                    </div>`,
                        data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            onRuleEdit: function(data) {
                                Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Editar norma', 'edit-rule', data);
                            },
                            onUnpin: function(data) {
                                axios.post('/auth/regulatoryAffairs/onUnpinRule',{
                                    data: {norma_id: data.id, cumplimiento_id: data.cumplimiento_id}
                                }).then((response) => {
                                    Vue.prototype.$eventHub.$emit('onGetCompliance');
                                    Vue.prototype.$eventHub.$emit('closeSidebarClick');
                                }).catch(error => {
                                        this.disabledButton = false;
                                });
                            }
                        }
                    })
                }
            },

            validateStatus: function (e) {
                return {
                    template: Vue.component('templateButtons', {
                        template: `<span v-bind:class="{'text-danger': data.status == 0 ? true : false, 'text-success': data.status == 0 ? false : true }">{{data.status == 0 ? 'Por cumplir' : 'Cumplido'}}</span>`,
                        data() {
                            return {
                                data: {}
                            };
                        }
                    })
                }
            }
        }
    },
    methods: {
        
    },
}
</script>